import { transferFile } from "@luckymenu/api-client";
import { IMAGE_MIMES } from "@luckymenu/core";
import type { FileAdapter, PickedFile } from "@luckymenu/staff-core";

/** Opens the browser's file chooser for images. Resolves null if it is closed without a choice. */
function chooseFile(accept: string): Promise<File | null> {
	return new Promise((resolve) => {
		const input = document.createElement("input");
		input.type = "file";
		input.accept = accept;
		input.style.display = "none";
		const done = (file: File | null) => {
			input.remove();
			resolve(file);
		};
		input.addEventListener("change", () => done(input.files?.[0] ?? null), { once: true });
		input.addEventListener("cancel", () => done(null), { once: true });
		document.body.append(input);
		input.click();
	});
}

/** Staff web: the browser's chooser, and XMLHttpRequest for progress. */
export const webFiles: FileAdapter = {
	async pickImage(): Promise<PickedFile | null> {
		const file = await chooseFile(IMAGE_MIMES.join(","));
		return file ? { name: file.name, mime: file.type, size: file.size, data: file } : null;
	},
	transfer(file, target, onProgress, signal) {
		if (!(file.data instanceof Blob)) throw new Error("Not a browser file");
		return transferFile(target, file.data, { onProgress, signal });
	},
};
